import { Backdrop, Box, Button, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import ArrowUpBendLeftIcon from '../../../assets/svg/meeting/arrowUpBendLeft.svg';
import { ROLE_VALUES } from '../../../constants/customerConstant';
import { useAuth } from '../../../contexts/auth/authContext';
import { useMeetingContext } from '../../../contexts/meeting/meetingContext';
import HeaderComponent from '../../common/headerComponent';
import LoadingComponent from '../../common/loadingComponent';

function VideoCallEndLayout() {
  const { userType } = useAuth();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { isMeetingEnded, endMeetingCustomMessage, joinMeeting, startMeeting } =
    useMeetingContext();

  return (
    <>
      <HeaderComponent isMenuHidden />
      {isLoading && (
        <Backdrop
          sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}
        >
          <LoadingComponent />
        </Backdrop>
      )}
      <Stack flexGrow={1} paddingTop={10}>
        <Stack direction={'row'} justifyContent='center'>
          <Stack gap={4}>
            <Stack direction={'row'} justifyContent='center'>
              <Typography
                sx={{ color: (theme) => theme.palette.neutralBlackBg[50] }}
                fontSize={28}
              >
                {endMeetingCustomMessage}
                {isMeetingEnded && !endMeetingCustomMessage && (
                  <FormattedMessage defaultMessage='The meeting has ended' />
                )}
                {!isMeetingEnded && !endMeetingCustomMessage && (
                  <FormattedMessage defaultMessage='You left the meeting' />
                )}
              </Typography>
            </Stack>

            <Stack direction={'row'} gap={2} justifyContent={'center'}>
              {!isMeetingEnded && (
                <Box>
                  <Button
                    variant='outlined'
                    sx={{
                      textTransform: 'none',
                      display: 'flex',
                      padding: '12px 32px',
                      justifyContent: 'center',
                      alignItems: 'center',
                      gap: '8px',
                      borderRadius: '50px',
                      border: (theme) =>
                        `2px solid ${theme.palette.neutralBlackBg[50]}`,
                      color: (theme) => theme.palette.neutralBlackBg[50],
                    }}
                    onClick={async () => {
                      setIsLoading(true);
                      await joinMeeting();
                      await startMeeting();
                    }}
                  >
                    <FormattedMessage defaultMessage='Rejoin' />
                  </Button>
                </Box>
              )}

              <Box>
                <Button
                  variant='outlined'
                  startIcon={
                    <img
                      src={ArrowUpBendLeftIcon}
                      alt='back'
                      style={{ height: 24 }}
                    />
                  }
                  sx={{
                    textTransform: 'none',
                    position: 'relative',
                    padding: '12px 32px',
                    borderImageSlice: 1,
                    borderRadius: '50px',
                    color: (theme) => theme.palette.neutralBlackBg[50],
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      inset: 0,
                      borderRadius: '50px',
                      padding: '2px',
                      background: (theme) =>
                        `linear-gradient(278deg, ${theme.palette.teal.main} -6.53%, ${theme.palette.blue.main} 97.07%)`,
                      WebkitMask:
                        'linear-gradient(#FFFFFF 0 0) content-box, linear-gradient(#FFFFFF 0 0)',
                      WebkitMaskComposite: 'xor',
                      maskComposite: 'exclude',
                    },
                  }}
                  onClick={() => {
                    if (userType === ROLE_VALUES.WHISTLE_BLOWER) {
                      navigate('/inbox');
                    } else {
                      navigate('/customer/reports');
                    }
                  }}
                >
                  <FormattedMessage defaultMessage='Back to report page' />
                </Button>
              </Box>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </>
  );
}

export default VideoCallEndLayout;
